import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid } from '@mui/material';
import CardModule from './CardModule';
import dayjs from 'dayjs';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import FilterSection from './FilterSection';
import { useDispatch } from 'react-redux';
import { topCardCounts } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';

const TopSection = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  const [projectId, setProjectId] = useState('');
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const dispatch = useDispatch();
  const {
    topsectionDashboard: { data, topsectionDashboardLoading },
  } = useSelector((state) => state.refund);

  const cardData = useMemo(
    () => [
      { title: 'Total Request', value: 'total_request' }, // Deep Blue
      ...(selectedType?.id ? [] : [{ title: 'Pending PM', value: 'pending_from_pm' }]), // Vibrant Orange/Red
      { title: 'Pending Finance', value: 'pending_from_finance' }, // Bright Blue
      { title: 'Approved', value: 'approved_from_finance' }, // Fresh Green
      { title: 'Rejected', value: 'rejected_from_finance' }, // Intense Red
      { title: 'Hold', value: 'hold_from_finance' }, // Golden
      { title: 'Highest Refunded OGA', value: 'most_refunded_oga' }, // Royal Purple
      ...(selectedType?.id
        ? []
        : [
            { title: 'Highest Refunded CRO', value: 'most_refunded_cro' }, // Teal/Lime
            { title: 'Top Reason', value: 'top_refund_reason' },
          ]),
    ],
    [data]
  );

  const dispatchParams = useMemo(() => {
    return {
      type: selectedType?.id,
      projectId: projectId,
      fromDate: fromDate,
      toDate: toDate,
    };
  }, [selectedType, projectId, fromDate, toDate]);

  useEffect(() => {
    dispatch(topCardCounts(dispatchParams));
  }, []);

  const filterSubmit = React.useCallback(() => {
    dispatch(topCardCounts(dispatchParams));
  }, [dispatch, dispatchParams]);
  return (
    <Box>
      {/* FILTER SECTION */}
      <FilterSection
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        projectId={projectId}
        setProjectId={setProjectId}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        filterSubmit={filterSubmit}
        loading={topsectionDashboardLoading}
      />
      <Grid container spacing={2} mt={0.5}>
        {cardData.map(({ title, value }, index) => {
          // console.log({ value: data?.total_request, key: value });

          return (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <CardModule
                title={title}
                value={data[0]?.[value] ?? 0}
                defalutColor={'linear-gradient(135deg, #4f94d7 0%, #002F6C 100%)'}
                loading={topsectionDashboardLoading}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default TopSection;
